import { useNavigate } from "react-router-dom";

import { Alert, Button, Empty, Spin } from "antd";
import React, { useEffect, useState } from "react";

import LegalContent from "@/components/common/LegalContent";
import { ESERVICES_PRIVACY_POLICY_TYPE, ROUTES_URL } from "@/constant";
import styles from "@/pages/PrivacyPolicy/PrivacyPolicy.module.css";
import { getEservicesPrivacyPolicy } from "@/services/Auth/AuthApi";

interface PolicyRecord {
  type?: string;
  content?: string;
  is_active?: boolean;
  is_deleted?: boolean;
}

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    setContent("");

    void getEservicesPrivacyPolicy()
      .then((response) => {
        if (response?.error) throw new Error("Unable to load Privacy Policy");
        const policy = response?.data?.find(
          (record: PolicyRecord) =>
            record.type === ESERVICES_PRIVACY_POLICY_TYPE &&
            record.is_active !== false &&
            record.is_deleted !== true,
        );
        if (!cancelled) setContent(policy?.content || "");
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [retryCount]);

  return (
    <div className={styles.gradientBg}>
      <div>
        <div className={styles.container}>
          <h1 className={styles.title}>Privacy Policy</h1>
          <Spin spinning={loading}>
            <div className={styles.policyContent}>
              {!loading &&
                (error ? (
                  <Alert
                    type="error"
                    message="Unable to load Privacy Policy. Please try again."
                    action={
                      <Button onClick={() => setRetryCount((count) => count + 1)}>Retry</Button>
                    }
                  />
                ) : content.trim() ? (
                  <LegalContent html={content} />
                ) : (
                  <Empty description="Privacy Policy is currently unavailable." />
                ))}
            </div>
          </Spin>
        </div>
        <div className={styles.backToLogin}>
          <Button
            htmlType="submit"
            className={styles.applyButton}
            onClick={() => navigate(ROUTES_URL.LOGIN)}
          >
            Back to Login
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
